import { useSelector } from 'react-redux';

import { PLAN_TYPES } from 'utlis/constants';

/**
 * Hook to check if the current user has a Pro subscription
 * This properly subscribes to Redux state changes and triggers re-renders
 * @returns {boolean} True if user is on Pro plan, false otherwise
 */
export const useIsPro = () => {
  const currentPlan = useSelector(state => state.proStore?.currentPlan);

  return currentPlan === PLAN_TYPES.PRO;
};
